import { useGetBffUserQuery } from 'redux/services/bffUserApi';

interface AppUser {
  givenName: string;
  familyName: string;
  email: string;
  logoutLink: string;
}

function useGetAppUser(): AppUser | undefined {
  const { data: claims } = useGetBffUserQuery();

  if (!claims) {
    return undefined;
  }

  const givenName = claims.find((claim) => claim.type === 'given_name')?.value ?? '';
  const familyName =
    claims.find((claim) => claim.type === 'family_name')?.value ?? '';
  const email = claims.find((claim) => claim.type === 'email')?.value ?? '';

  const logoutLink =
    claims.find((claim) => claim.type === 'bff:logout_url')?.value ?? '';

  if (!logoutLink || !email) {
    return undefined;
  }

  return {
    givenName,
    familyName,
    email,
    logoutLink,
  };
}

export default useGetAppUser;
